import { render, staticRenderFns } from "./CustomTranslationsDataTable.vue?vue&type=template&id=5cd1ca13&"
import script from "./CustomTranslationsDataTable.vue?vue&type=script&lang=js&"
export * from "./CustomTranslationsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports